import AxiosInterceptor from "../../AxiosInterceptorMomthera";

// DP-DTX-006-ADMIN 사용자 정보 조회
export function getUserInfoFromMomthera() {
	return AxiosInterceptor({
		url: '/signup/dpdtx006admin',
		method: 'get'
	})
}

// DP-DTX-006-ADMIN 서비스 가입 정보 삭제
// request data
//	- 비밀번호
export function deleteSignupDpdtx006AdminFromMomthera(request) {
	return AxiosInterceptor({
		url: '/signup/dpdtx006Admin',
		method: 'delete',
		data: request
	})
}

// 프로파일 사진 조회
export function getUserProfileImageFromMomthera() {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'get',
        responseType: 'blob'
	})
}

// 프로필 사진 업로드
export function putStaffProfileImgToMomthera(request) {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'put',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		data: request
	})
}